export const UserRoles = {
    ADMINISTRATOR: "Administrator",
    MARKETING: "Marketing",
    RND: "R&D",
} as const;
export type UserRolesTypes = typeof UserRoles[keyof typeof UserRoles];
